<template>
    <div
        :id="id"
        class="tl-view-document"
        @click="emit('download-document', { ...resource, componentId: id })"
    >
        <i
            style="margin-right: 8px"
            class="mi-document"
        />
        <p>{{ linkDescription }}</p>
        <i class="mi-download" />
    </div>
</template>

<script setup lang="ts">
import type { DisplayDocumentPayload } from 'widget-components/types/DisplayDocument'

defineOptions({ inheritAttrs: false })

defineProps<{
    id?: string
    resource: DisplayDocumentPayload
    linkDescription: string
}>()

const emit = defineEmits<{
    (e: 'download-document', resource: DisplayDocumentPayload): void
}>()
</script>

<style lang="sass" scoped>
.tl-view-document
    font-family: var(--font-family-primary)
    font-size: var(--tl-font-size, 16px)
    display: flex
    align-items: center
    background-color: var(--tl-container-bg-color)
    border-radius: var(--tl-container-border-radius)
    border: 1px solid var(--color-black-tint-light)
    padding: 16px
    transition: opacity .3s ease-in-out
    cursor: pointer

    p
        flex: 1

    i
        color: var(--color-tl-blue)

    &:hover
        opacity: .5
</style>
